<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectDescription from '@app/components/projects/elements/ProjectDescription.svelte';
	import ProjectDevelopmentSteps from '@app/components/projects/elements/ProjectDevelopmentSteps.svelte';
	import ProjectNREInfo from '@app/components/projects/elements/ProjectNREInfo.svelte';
	import ProjectPhotoGallery from '@app/components/projects/elements/ProjectPhotoGallery.svelte';
	import ProjectProofOfTransparency from '@app/components/projects/elements/ProjectProofOfTransparency.svelte';
	import ProjectScoringESG from '@app/components/projects/elements/ProjectScoringESG.svelte';
	import ProjectLocalization from '@app/components/projects/elements/ProjectLocalization.svelte';
	import RealEstatePerformanceSimulator from '@app/components/projects/elements/real-estate/RealEstatePerformanceSimulator.svelte';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum.js';
	import { OperationFinancialInstrumentEnum } from '@app/models/api/enums/OperationFinancialInstrumentEnum.js';

	export let operation: OperationModel;
</script>

<ProjectDescription {operation} />
<ProjectPhotoGallery {operation} />
<ProjectLocalization {operation} />
{#if operation.status?.includes(OperationStatusEnum.FUNDING) && !operation.clotureEnCours && operation.financialInstrument === OperationFinancialInstrumentEnum.BONDS && !operation.isVariableRate}
	<RealEstatePerformanceSimulator {operation} />
{/if}
<ProjectScoringESG {operation} />

<ProjectNREInfo {operation} />
<ProjectDevelopmentSteps {operation} />

<ProjectProofOfTransparency {operation} />
